import PropTypes from 'prop-types'

const DownloadIcon = ({stroke = 'var(--brand-primary)', height = '16', width = '16', ...otherProps}) => (
  <svg {...otherProps} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M11.9675 0.9375V16.535M4.6125 9.95625L10.64 15.9837C11.0063 16.35 11.4862 16.5338 11.965 16.5338M19.3187 9.95625L13.2913 15.9837C12.925 16.35 12.445 16.5338 11.9662 16.5338M22.8125 17.5187V18.6875C22.8125 19.2292 22.7058 19.7656 22.4985 20.2661C22.2912 20.7665 21.9874 21.2213 21.6043 21.6043C21.2213 21.9874 20.7665 22.2912 20.2661 22.4985C19.7656 22.7058 19.2292 22.8125 18.6875 22.8125H5.0625C4.5208 22.8125 3.9844 22.7058 3.48393 22.4985C2.98346 22.2912 2.52873 21.9874 2.14568 21.6043C1.76264 21.2213 1.4588 20.7665 1.2515 20.2661C1.0442 19.7656 0.9375 19.2292 0.9375 18.6875V17.5187' stroke={stroke} strokeWidth='1.875' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

DownloadIcon.propTypes = {
  height: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.string
}

export default DownloadIcon
